import CatalogPage from '@/components/feature/CatalogPage';
import { useDocumentMeta } from '@/hooks/useDocumentMeta';

export default function TvShows() {
  useDocumentMeta(
    '星辰影院-热门电视剧分类浏览',
    '星辰影院电视剧分类页，覆盖国产剧、美剧、韩剧、日剧等热门剧集，突出季数与集数信息，支持按类型、年份、地区筛选及多种排序方式。',
    '热门电视剧,电视剧分类,电视剧筛选,国产剧,美剧,韩剧,星辰影院',
  );

  return (
    <CatalogPage
      type="tv"
      title="电视剧分类"
      description="覆盖国产剧、美剧、韩剧、日剧等热门剧集，每条剧集均标注季数与集数信息。通过左侧筛选栏按类型、年份、地区组合筛选，并按最新、热门、评分排序浏览。"
    />
  );
}